import React, {useEffect} from 'react';
import * as SentryReact from '@sentry/react';
import ENV from '../environment';
const SentryWrapper = () => {
  const dsnNumber = ENV.SENTRY_DSN;
  useEffect(() => {
    if (!ENV.DEBUG_ENABLED) {
      SentryReact.init({
        dsn: dsnNumber,
        // Must match the release the sourcemaps are uploaded under in
        // webpack.config.js (injected via DefinePlugin); without this, GlitchTip
        // cannot de-minify stack traces.
        release: process.env.SENTRY_RELEASE,
        tracesSampleRate: 0.5,
        autoSessionTracking: false,
        ignoreErrors: [
          /\d+ms timeout exceeded/,
          /Internal error opening backing store for indexedDB\.open/,
          /backing store for indexedDB/,
          /Network Error/,
          /NetworkError/,
          /EventSource error/,
          /Permissions check failed/,
          /not granted/,
          /Failed to start the audio device/,
          /Cannot request fullscreen in a hidden document/,
          /Database deleted by request of the user/,
          /Connection to Indexed Database server lost/,
          /Attempt to get a record from database without an in-progress transaction/,
          /TimeoutError: Transaction timed out/,
          /QuotaExceededError/,
          /AbortError.*IDBTransaction/,
          /A request was aborted/,
          /Request failed with status code 401/,
          /Request failed with status code 403/,
          /Non-Error promise rejection captured with value: null/,
          /scrollToIndex out of range/,
          /Converting circular structure to JSON/,
          // Browser compat: requestFullscreen not available on some devices
          /requestFullscreen is not a function/i,
          // Dashboard embed SDK calling replaceChildren on unmounted container
          /Cannot read properties of null \(reading 'replaceChildren'\)/,
          // React error #185: setState on unmounted component (benign async race)
          /Minified React error #185/,
          // Failed to construct URL: empty/invalid href (user data issue, not our code)
          /Failed to construct 'URL': Invalid URL/,
          // Firefox-for-iOS's own reader-mode script injected into the page
          // (reports UA as Mobile Safari since iOS mandates WebKit) — not our code.
          /__firefox__/,
        ],
        denyUrls: [
          /chrome-extension:\/\//,
          /extensions\//,
          /^chrome:\/\//,
          /^moz-extension:\/\//,
          // Third-party analytics scripts throw their own (non-actionable)
          // cross-origin / SecurityErrors — not our code.
          /clarity\.js/,
          /clarity\.ms/,
          // In-browser Stockfish WASM engine crashes (RangeError on alloc,
          // RuntimeError "unreachable", etc. — the exact message varies).
          // engine.ts's worker.onerror already calls preventDefault() and
          // enginePool.ts's recoverLane() transparently reinitializes the
          // engine, but the crash was STILL reaching GlitchTip via
          // window.onerror regardless (confirmed in production after the
          // preventDefault fix shipped — some other instrumentation observes
          // the worker error event independent of preventDefault). Filtering
          // by originating script is mechanism-independent and catches every
          // message variant; this was ~56% of this project's total issue
          // volume (CC-LEARNING-8F).
          /\/stockfish(-18-lite-single)?\.js/,
        ],
      });
    }

    return () => {
      SentryReact.close();
    };
  }, [dsnNumber]);

  return null;
};

export default SentryWrapper;
